<div class="bg-[url(/assets/backgrounds/login-screen.png)] bg-center bg-cover">
  <div class="backdrop-brightness-40 backdrop-saturate-0">
    <div class="h-full flex container max-xl:max-w-[-webkit-fill-available] xl:mx-auto justify-between items-center">
    <div class="grow">
      <div class="grid grid-rows-[fr_72px] min-h-dvh">
        <div class="flex flex-col items-center justify-center">
          <section class="w-full max-w-lg p-8 py-6 rounded-lg bg-white/90 shadow max-h-dvh overflow-auto">
            <header class="mb-4">
              <h1 class="text-2xl font-bold text-center">Reset Password</h1>
            </header>
            <main>
              <form [formGroup]="form" (ngSubmit)="formState.submit()" class="space-y-4">
                <tui-input formControlName="password">
                  Password
                  <input appPasswordComplexity tuiTextfieldLegacy type="password" />
                </tui-input>
                <tui-error formControlName="password" [error]="[] | tuiFieldError | async" />

                <tui-input formControlName="repeatPassword">
                  Repeat Password
                  <input tuiTextfieldLegacy type="password" />
                </tui-input>
                <tui-error formControlName="repeatPassword" [error]="[] | tuiFieldError | async" />
                <div class="actions">
                  <button tuiButton appearance="primary" size="l" type="submit" [disabled]="!form.valid || formState.status() == 'submitting'" class="w-full">
                    Reset Password
                  </button>
                </div>
              </form>
            </main>
          </section>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
